import {
  BriefcaseBusiness, Building2, Code2, Factory, FolderKanban, GraduationCap,
  HeartPulse, Landmark, Rocket, ShoppingBag, Target, Users,
} from "lucide-react";

export const WORKSPACE_ICONS = [
  ["building-2", "Empresa", Building2],
  ["briefcase-business", "Negocio", BriefcaseBusiness],
  ["users", "Equipo", Users],
  ["target", "Objetivos", Target],
  ["rocket", "Producto", Rocket],
  ["factory", "Operaciones", Factory],
  ["code-2", "Tecnología", Code2],
  ["shopping-bag", "Comercial", ShoppingBag],
  ["graduation-cap", "Formación", GraduationCap],
  ["heart-pulse", "Salud", HeartPulse],
  ["landmark", "Institución", Landmark],
  ["folder-kanban", "Proyectos", FolderKanban],
];

const ICONS = Object.fromEntries(WORKSPACE_ICONS.map(([key, , Icon]) => [key, Icon]));

export default function WorkspaceIcon({ iconKey, size = 18, ...props }) {
  const Icon = ICONS[iconKey] || Building2;
  return <Icon size={size} aria-hidden="true" {...props} />;
}
